import React from 'react';
import {handleAddCardRequest} from "../../../Functions/Checkout/handleAddCardRequest";
import {toast} from "react-toastify";
import {IBank} from "../../../Components/PageSections/Checkout/BankCards";

interface IProps {
  bank: IBank;
  isChecked: boolean
}

const ChoseBank = ({bank, isChecked}: IProps) => {
  return (
      <div
          onClick={async () => {
            if (isChecked) {
              await handleAddCardRequest(toast, false, {method: bank.id});
            } else {
              toast("ბარათის სისტემაში დამატებისთვის, გთხოვთ, დაეთანხმოთ ბარათის დამახსოვრებას.", {
                type: "error",
                position: "bottom-right",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                draggable: true,
                theme: "light",
              })
            }
          }}
          className={"cursor-pointer transition-all p-5 rounded-xl bg-[white] border-[transparent] hover:border-[#23AD61] border-[1px] flex justify-between items-center"}>
        <div className="flex items-center">
          <div className={"bg-[#FFF] flex items-center justify-center w-10 h-10 rounded-xl mr-2"}>
            <img
                alt={bank?.id + " logo"}
                className="max-w-[24px] w-6 h-6 min-h-6 min-w-6"
                src={bank?.img}
            />
          </div>
          <div className={""}>
            <span className="text-sm font-bold text-blackPrimary-100">
              {bank?.name?.toUpperCase()}
            </span>
            <p className="text-[12px] text-lightgray font-demi uppercase">
              {bank?.label}
            </p>
          </div>
        </div>
      </div>
  );
};

export default ChoseBank;